// extracted by mini-css-extract-plugin
export var label = "stringField-module--label--2babf";
export var text = "stringField-module--text--c0b40";
export var wrapper = "stringField-module--wrapper--d4b10";